import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from '../footer/footer.scss';
import progressBarSelector from '../../selectors/progress/ProgressBarSelector';

const ProgressBar = ({ maxProgress, currentProgress, progressBarLabel }) => {
    return (
        <div className={styles.progressBarWrapper}>
            {/* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/no-noninteractive-element-to-interactive-role */}
            <progress
                tabIndex="0"
                role="progressbar"
                aria-valuetext={progressBarLabel}
                id="progressBar"
                max={maxProgress}
                aria-valuemax={maxProgress}
                value={currentProgress}
                aria-valuemin={currentProgress}
            />
        </div>
    );
};

ProgressBar.propTypes = {
    currentProgress: PropTypes.number.isRequired,
    maxProgress: PropTypes.number.isRequired,
    progressBarLabel: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
    return progressBarSelector.mapPropsToProps(state);
}

const ProgressBarContainer = connect(mapStateToProps)(ProgressBar);
export default ProgressBarContainer;
